<figure class="logo">
      <img defaultImage="/images/pixel.png"  lazyLoad="/images/logos/paraty-tours.svg" alt="Paraty Tours" width="220px" />
</figure>     